import { SET_IS_USER_ONBOARDING } from "./onboardingActions";

const initialState = {
  isUserOnboarding: false
};

export default (state = initialState, action) => {
  switch (action && action.type) {
    case SET_IS_USER_ONBOARDING: {
      return { ...state, isUserOnboarding: action.payload };
    }
    default:
      return { ...state };
  }
};
